<template>
  <div v-if="isVisible" class="ads-modal-overlay" @click.self="closeModal">
    <div class="ads-modal-container">
      <button class="ads-close-btn" @click="closeModal" aria-label="Cerrar publicidad">
        &times;
      </button>

      <a :href="adTargetUrl" target="_blank" rel="noopener noreferrer" class="ads-link">
        <picture>
          <source media="(max-width: 768px)" :srcset="adPngUrl" />
          <img :src="adGifUrl" alt="Publicidad" class="ads-image" />
        </picture>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdsModalComp",
  data() {
    return {
      isVisible: true,
      adGifUrl: require("@/assets/images/AdsPeruWeek-desktop.gif"), 
      adPngUrl: require("@/assets/images/AdsPeruWeek-mobile.png"), 
      // Configuración de WhatsApp:
      whatsappPhone: process.env.VUE_APP_WHATSAPP_SALES_NUMBER1,
      whatsappMessage: "¡Hola! Quiero ir a Perú", // Mensaje inicial
    };
  },
  computed: {
    // Genera automáticamente el enlace codificado correctamente
    adTargetUrl() {
      const textEncoded = encodeURIComponent(this.whatsappMessage);
      return `https://wa.me/${this.whatsappPhone}?text=${textEncoded}`;
    }
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
/* Fondo oscuro translúcido */
.ads-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

/* Contenedor plano (esquinas en punta) */
.ads-modal-container {
  position: relative;
  background-color: #ffffff;
  border-radius: 0px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  max-width: 90vw;
  max-height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

/* Enlace e Imagen */
.ads-link {
  display: block;
  line-height: 0;
}

.ads-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  display: block;
  border-radius: 0px;
  cursor: pointer;
}

/* Botón flotante circular */
.ads-close-btn {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--color-acento-secundario, #1a4a8c);
  color: #ffffff;
  border: 2px solid #ffffff;
  font-size: 22px;
  font-weight: bold;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, background-color 0.2s ease;
  z-index: 10;
}

.ads-close-btn:hover {
  background-color: var(--color-acento-primario, #00bdd6);
  transform: scale(1.1);
}

/* Ajustes Responsive */
@media (max-width: 768px) {
  .ads-modal-container {
    max-width: 85vw; /* Ajusta el ancho para que el PNG vertical encaje bien */
    max-height: 80vh;
  }

  .ads-close-btn {
    top: -12px;
    right: -12px;
    width: 32px;
    height: 32px;
    font-size: 18px;
  }
}
</style>